import { PlaceEntry, Tag } from 'modules/Telematics/types';

export const separateAndGetPolyPathAndDryPath = (places: Array<PlaceEntry>) => {
	let dryRunPlaces: Array<PlaceEntry> = [];
	let polyLinePlaces: Array<PlaceEntry> = [];

	places.forEach((p) => {
		for (let i = 0; i < p.tags.length; i++) {
			if (p.tags[i].TagPropertyKey === 'TagProperty_SEGMENT_TYPE') {
				if (p.tags[i].value.stringValues.includes('DRY_RUN_SEGMENT')) {
					dryRunPlaces.push(p);
				} else if (
					p.tags[i].value.stringValues.includes('POLY_SEGMENT')
				) {
					polyLinePlaces.push(p);
					break;
				}
			}
		}
	});

	return { dryRunPlaces, polyLinePlaces };
};

const getValueFromTag = (t: Tag) => {
	switch (t.value.valueType) {
		case 'VALUE_TYPE_DOUBLE':
			return t.value.floatValues[0];
		case 'VALUE_TYPE_INT32':
			return t.value.int32Values[0];
		case 'VALUE_TYPE_BOOLEAN':
			return t.value.boolValues[0];
		case 'VALUE_TYPE_STRING':
			return t.value.stringValues[0];
		case 'VALUE_TYPE_INT64':
			return t.value.int64Values[0];
		default:
			return 0;
	}
};

export const processTagsData = (tags: Tag[]) => {
	let rows: { [x: string]: number | string | boolean } = {};
	tags.forEach((tag) => {
		rows[tag.TagPropertyKey] = getValueFromTag(tag);
	});
	return rows;
};

export const isLocationObjectDifferent = (obj1: any, obj2: any) => {
	let isDifferent = false;
	const keys = ['machineId', 'startDate', 'endDate', 'rawData'];
	// eslint-disable-next-line no-restricted-syntax
	for (let i = 0; i < keys.length; i++) {
		if (obj1[keys[i]] !== obj2[keys[i]]) {
			isDifferent = true;
			break;
		}
	}
	return isDifferent;
};
